module.exports = __webpack_public_path__ + "static/media/portfolio5.842b0205.jpeg";